"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaybackDiscordActivity = exports.EMPTY_DISCORD_TIMESTAMPS = void 0;
var EMPTY_DISCORD_TIMESTAMPS = {
    startTimestamp: null,
    endTimestamp: null,
};
exports.EMPTY_DISCORD_TIMESTAMPS = EMPTY_DISCORD_TIMESTAMPS;
var getDiscordSeconds = function (time) {
    return typeof time === 'number' && Number.isFinite(time) ?
        Math.max(Math.floor(time / 1000), 0)
        :
            null;
};
var formatDiscordTime = function (seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds / 60) % 60);
    var remainingSeconds = seconds % 60;
    var pad = function (value) { return "0".concat(value).slice(-2); };
    return hours > 0 ?
        "".concat(pad(hours), ":").concat(pad(minutes), ":").concat(pad(remainingSeconds))
        :
            "".concat(pad(minutes), ":").concat(pad(remainingSeconds));
};
var formatPausedDiscordState = function (time, duration) {
    var elapsedSeconds = getDiscordSeconds(time);
    var durationSeconds = getDiscordSeconds(duration);
    if (elapsedSeconds === null || durationSeconds === null) {
        return 'Paused';
    }
    return "Paused at ".concat(formatDiscordTime(elapsedSeconds), " / ").concat(formatDiscordTime(durationSeconds));
};
var getPlayingDiscordTimestamps = function (timestamps, time, duration) {
    var elapsedSeconds = getDiscordSeconds(time);
    if (elapsedSeconds === null) {
        return EMPTY_DISCORD_TIMESTAMPS;
    }
    var nowTimestamp = Math.floor(Date.now() / 1000);
    var startTimestamp = nowTimestamp - elapsedSeconds;
    var durationSeconds = getDiscordSeconds(duration);
    var endTimestamp = durationSeconds === null ?
        null
        :
            nowTimestamp + Math.max(durationSeconds - elapsedSeconds, 0);
    return {
        startTimestamp: timestamps.startTimestamp === null || Math.abs(timestamps.startTimestamp - startTimestamp) > 5 ?
            startTimestamp
            :
                timestamps.startTimestamp,
        endTimestamp: endTimestamp === null || timestamps.endTimestamp === null || Math.abs(timestamps.endTimestamp - endTimestamp) > 5 ?
            endTimestamp
            :
                timestamps.endTimestamp,
    };
};
var getPlaybackDiscordActivity = function (_a) {
    var title = _a.title, image = _a.image, paused = _a.paused, time = _a.time, duration = _a.duration, timestamps = _a.timestamps;
    var nextTimestamps = paused === true ?
        EMPTY_DISCORD_TIMESTAMPS
        :
            getPlayingDiscordTimestamps(timestamps, time, duration);
    return {
        activity: {
            state: paused === true ? formatPausedDiscordState(time, duration) : 'Watching',
            details: title,
            image: image,
            startTimestamp: nextTimestamps.startTimestamp,
            endTimestamp: nextTimestamps.endTimestamp,
        },
        timestamps: nextTimestamps,
    };
};
exports.getPlaybackDiscordActivity = getPlaybackDiscordActivity;
